// extracted by mini-css-extract-plugin
export default {"showcase":"VisualDownloadImagesShowcase_showcase__FSPXd","smallSample":"VisualDownloadImagesShowcase_smallSample__h1Kzs","image":"VisualDownloadImagesShowcase_image__LPtyw"};